import React from 'react';
import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { getErrorsText } from '../ErrorNotification';

interface Props {
  error?: Error | Error[] | string | string[];
}

export const ErrorMessage: React.FC<Props> = ({ error }: Props) => {
  return (
    <Box m={1}>
      <Alert severity="error">{error ? getErrorsText(error) : 'Something went wrong.'}</Alert>
    </Box>
  );
};
